import React from "react"
import {Link, withPrefix} from 'gatsby';
import Layout from "../../components/layout";
import SEO from "../../components/seo"

class SubCategoryPage extends React.Component {

  render() {
    const {cat, sub} = this.props.pageContext;
    // console.log('SubCategoryPage', this.props.pageContext);
    const commonLink='/catalog/cmo';
    const parentCatLink = `${commonLink}/catalog`;
    const pageTitle = `ЦМО: ${cat.title}`;

    return <Layout>
        <SEO title={pageTitle} />
        <div id="main" className='catalog'>
            <div className="inner">
                <div className='parent-category'>
                    <Link to={parentCatLink}>&larr; Телекоммуникационное оборудование ЦМО</Link>
                </div>
                <h1>{cat.title}</h1>
                <section className='categories'>
                  <div className="box alt">
                      <div className="row gtr-uniform">
                      {sub && sub.map((item, i) => {
                          const link = `${commonLink}${item.url}`;
                          const img = withPrefix(item.imgExtended);
                          return <div key={i} className="col-sm-12 col-md-4 category-item">
                          <Link to={link}>
                              <div className="image fit">
                                  <img src={img} alt={item.title} />
                              </div>
                              <h3>{item.title}</h3>
                          </Link>
                          </div>
                      })}

                      </div>
                  </div>
                </section>
            </div>
        </div>
    </Layout>;
  }
}

export default SubCategoryPage;
